import { Error403Unauthorized } from '@app/components';

import { useIndividualCalendarContext } from '@pages/IndividualCalendar/context';
import { useIndividualCalendarPermissions } from '@pages/IndividualCalendar/hooks';

import { IndividualCalendarLayout } from '../../IndividualCalendarLayout';

import type { FC } from 'react';

import '../styles/IndividualCalendarPage.scss';

export interface IndividualCalendarPageProps {}

export const IndividualCalendarPage: FC = () => {
  const { currentEmployeeId, todayMoment } = useIndividualCalendarContext();
  const { canViewPage } = useIndividualCalendarPermissions({
    currentEmployeeId,
    todayMoment,
  });

  return (
    <div
      className="IndividualCalendarPage"
      data-testid="individual-calendar-page"
    >
      {canViewPage ? <IndividualCalendarLayout /> : <Error403Unauthorized />}
    </div>
  );
};
